import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, MapPinIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { UpsellOption, getCheckoutUrl } from '../data/copy';
export function Hero({
  selectedUpsell
}: {
  selectedUpsell: UpsellOption;
}) {
  return <header className="relative isolate w-full overflow-hidden bg-abyss" data-id="element-59" data-mp="4m8kg77n0hia">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/87dd5680-0bb1-4bcd-8cf4-38d1de0d17bf.jpg" alt="Pescador mexicano sosteniendo una lobina trofeo al amanecer en una presa" className="absolute inset-0 h-full w-full object-cover object-center opacity-55" data-id="element-60" data-mp="129h1nq0lv4eh" />
      <div className="absolute inset-0 bg-abyss/70" aria-hidden="true" data-id="element-61" data-mp="ncglmjrs0xvu" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-abyss to-transparent" aria-hidden="true" data-id="element-62" data-mp="neauv0tor1k3" />

      <div className="relative mx-auto flex min-h-[62vh] max-w-6xl flex-col justify-end px-4 pb-8 pt-14 sm:min-h-[80vh] sm:px-8 sm:pb-20 sm:pt-24" data-id="element-63" data-mp="381xjaspbqs7j">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-64" data-mp="3j9aldp7jncay">
          <div className="mb-3 flex flex-wrap items-center gap-x-3 gap-y-1 font-cond text-[0.68rem] uppercase tracking-[0.16em] text-chartreuse sm:mb-6 sm:text-sm sm:tracking-[0.2em]" data-id="element-65" data-mp="399tej4gk2sde">
            <span className="flex items-center gap-1.5" data-id="element-66" data-mp="30gzuktq5z4t7">
              <MapPinIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-67" data-mp="358rdqj6zq89b" />
              Hecho a mano en México
            </span>
            <span className="hidden h-4 w-px bg-bone/30 sm:block" aria-hidden="true" data-id="element-68" data-mp="2qkwj2x9f9ttl" />
            <span className="text-bone/70" data-id="element-69" data-mp="2vi55ja1lsk0n">El Salto · Comedero · Aguamilpa</span>
          </div>

          <h1 className="font-display text-[1.9rem] uppercase leading-[0.95] text-bone sm:text-6xl sm:leading-[0.92] lg:text-[5rem]" data-id="element-70" data-mp="2hix03zeukfo0">
            La lobina de tu vida no está esperando
            <span className="block text-chartreuse" data-id="element-71" data-mp="s2jmpvqkdyiz">
              otro pedazo de plástico muerto.
            </span>
          </h1>

          <p className="mt-4 max-w-2xl font-body text-[0.95rem] leading-relaxed text-bone/80 sm:mt-6 sm:text-xl" data-id="element-72" data-mp="najhpovn0ffj">
            Polímero de alta memoria para que la cola nunca deje de vibrar,
            aroma amasado dentro de la mezcla y colores moldeados a mano en
            México. Movimiento que se siente antes de verse.
          </p>

          <div className="mt-5 flex flex-col items-stretch gap-2.5 sm:mt-9 sm:flex-row sm:items-center sm:gap-4" data-id="element-73" data-mp="1ayjhfeaxfg69">
            <div className="flex flex-col gap-2" data-id="element-74" data-mp="112g4ddejdx4j">
              <CtaButton size="md" source="hero" href="#pack" itemName={selectedUpsell.title} value={selectedUpsell.price} className="sm:hidden" data-id="element-75" data-mp="11152jj4nizg2">
                ¡Quiero pescar más ya! → ${selectedUpsell.price}
              </CtaButton>
              <CtaButton source="hero" href="#pack" itemName={selectedUpsell.title} value={selectedUpsell.price} className="hidden sm:inline-flex" data-id="element-76" data-mp="3hrd80rmt53yb">
                ¡Quiero pescar más ya! → ${selectedUpsell.price}
              </CtaButton>
              <a href="#garantia" className="flex items-center justify-center gap-1.5 font-cond text-xs uppercase tracking-wide text-chartreuse hover:underline sm:justify-start sm:text-sm" data-id="element-77" data-mp="21by0lbsix4ei">
                <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-78" data-mp="2b2smgf1uy1zf" />
                Dos salidas o te devolvemos ${selectedUpsell.price}
              </a>
            </div>
            
            <div className="flex flex-col gap-2 sm:ml-2" data-id="element-79" data-mp="2kxkihefskgs3">
              <span className="flex items-center justify-center gap-2 font-cond text-[0.8rem] uppercase tracking-wider text-bone/65 sm:justify-start sm:text-base" data-id="element-80" data-mp="2p0qpioaqabzm">
                <FlameIcon className="h-4 w-4 text-blood sm:h-5 sm:w-5" aria-hidden="true" data-id="element-81" data-mp="2txhdrywosdw4" />
                120 packs por corrida y se acaban
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </header>;
}